import React, {useEffect, useRef, useState} from "react";


import SectionContainerComponent from "@Components/Sections/SectionContainer";


import {
    ButtonComponent,
    FormComponent, FormContentComponent,
    FormHeaderComponent, FormSectionComponent, InputComponent
} from "@Components/Forms";


import "./index.scss";
import {InputComponentStatusType} from "@Components/Forms/Inputs/Input/types";
import isEmail from "validator/lib/isEmail";
import {Col} from "react-bootstrap";
import scrollToDomElement from "@Utilities/Scrolling";


export const ContactUsPageContactForm:React.FC = () => {

    const contactFormRef = useRef(null);

    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [emailAddress, setEmailAddress] = useState('');
    const [message, setMessage] = useState('');

    const [firstNameStatus, setFirstNameStatus] = useState<InputComponentStatusType | null>(null);
    const [lastNameStatus, setLastNameStatus] = useState<InputComponentStatusType | null>(null);
    const [emailAddressStatus, setEmailAddressStatus] = useState<InputComponentStatusType | null>(null);
    const [messageStatus, setMessageStatus] = useState<InputComponentStatusType | null>(null);

    const [contactFormSubmittedStatus, setContactFormSubmittedStatus] = useState(false);

    useEffect(() => {
        return () => {
            setFirstName('');
            setLastName('');
            setEmailAddress('');
            setMessage('');
            setFirstNameStatus(null);
            setLastNameStatus(null);
            setEmailAddressStatus(null);
            setMessageStatus(null);
            setContactFormSubmittedStatus(false);
        };
    }, []);

    useEffect(() => {
        if (contactFormRef?.current) {
            scrollToDomElement(contactFormRef?.current, 100);
        }
    }, [contactFormSubmittedStatus]);


    const changeFirstName = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (firstNameStatus?.type === 'error' && value.length > 1) {
            setFirstNameStatus({ type: 'success' });
        }
        setFirstName(value);
    }

    const changeLastName = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (lastNameStatus?.type === 'error' && value.length > 1) {
            setLastNameStatus({ type: 'success' });
        }
        setLastName(value);
    }

    const changeEmailAddress = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (emailAddressStatus?.type === 'error' && isEmail(value)) {
            setEmailAddressStatus({ type: 'success' });
        }
        setEmailAddress(value);
    }


    const contactFormSubmitHandler = () => {

        let error = false;

        if (firstName.length < 2) {
            error = true;
            setFirstNameStatus({ type: 'error', message: 'Name is too short' });
        }

        if (lastName.length < 2) {
            error = true;
            setLastNameStatus({ type: 'error', message: 'Name is too short' });
        }

        if (!isEmail(emailAddress)) {
            error = true;
            setEmailAddressStatus({ type: 'error', message: 'Email is invalid' });
        }

        if (error) {
            return;
        }

        contactFormMessageRequestHandler();

    };


    const contactFormMessageRequestHandler = async () => {

        const formData = new FormData()

        formData.append('name', firstName);
        formData.append('surname', lastName);
        formData.append('email', emailAddress);
        formData.append('message', message);

        try {
            const response = await fetch(
                'https://qyvo-engine.webpros.pl/api/v1/qyvo-users/contact-form-message/',
                { method: 'POST', body: formData }
            );
            if (response.ok) {
                setContactFormSubmittedStatus(true);
            }
        } catch (e) {
            console.error(e);
        }

    };


    return (
        <SectionContainerComponent ref={contactFormRef} id={'contact-us-page__contact-form'}>

            <FormComponent xs={12} xl={7}>

                <FormHeaderComponent
                    headerTitle={'Send Us a Message'}
                    headerDescription={'We\'ll get back to you within 24 hours'}
                />

                {!contactFormSubmittedStatus &&
                <FormContentComponent>

                    <FormSectionComponent>

                        <InputComponent
                            value={firstName}
                            setValue={changeFirstName}
                            label={'First Name'}
                            name={'contact_form_first_name'}
                            status={firstNameStatus}
                            required={true}
                            xl={6}
                            cssClasses={['contact-form-first-name-field']}
                        />

                        <InputComponent
                            value={lastName}
                            setValue={changeLastName}
                            label={'Last Name'}
                            name={'contact_form_last_name'}
                            status={lastNameStatus}
                            required={true}
                            xl={6}
                            cssClasses={['contact-form-last-name-field']}
                        />

                        <InputComponent
                            value={emailAddress}
                            setValue={changeEmailAddress}
                            label={'E-mail address'}
                            name={'contact_form_email_address'}
                            status={emailAddressStatus}
                            required={true}
                            cssClasses={['contact-form-email-address-field']}
                        />

                        <InputComponent
                            as={'textarea'}
                            value={message}
                            setValue={(e) => setMessage(e.target.value)}
                            label={'Message'}
                            name={'contact_form_message'}
                            status={messageStatus}
                            cssClasses={['contact-form-message-field']}
                            required={true}
                        />

                    </FormSectionComponent>

                    <FormSectionComponent>
                        <ButtonComponent
                            text={'Send Message'}
                            type={'cta'}
                            size={'l'}
                            callback={contactFormSubmitHandler}
                        />
                    </FormSectionComponent>

                </FormContentComponent>
                }

                {contactFormSubmittedStatus &&
                <Col xs={12} className={'contact-form-submit-message success-message'}>
                    <span>Message has been sent</span>
                </Col>
                }

            </FormComponent>



        </SectionContainerComponent>
    )

};


export default ContactUsPageContactForm;
